<script setup>
import Icon from '@/components/shared/icons/Icon.vue'

//Emits and props
defineEmits([
  'click',
])
defineProps({
  label: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
  href: {
    type: String,
    default: '',
  },
  route: {
    type: Object,
    default: null,
  },
})
</script>

<template>
  <li
    :class="$style.wrapper"
    @click="$emit('click', $event)"
  >
    <RouterLink
      v-if="route"
      :to="route"
      :class="$style.item"
      :aria-label="label"
      tabindex="0"
    >
      <Icon
        v-if="icon"
        :icon="icon"
        size="s"
        is-outlined
        :class="$style.icon"
      />
      <span :class="$style.label">
        <slot name="label">{{ label }}</slot>
      </span>
    </RouterLink>
    <a
      v-else-if="href"
      :href="href"
      :class="$style.item"
      tabindex="0"
      :aria-label="label"
    >
      <Icon
        v-if="icon"
        :icon="icon"
        size="s"
        is-outlined
        :class="$style.icon"
      />
      <span :class="$style.label">
        <slot>{{ label }}</slot>
      </span>
    </a>
    <div
      v-else
      :class="$style.item"
      tabindex="0"
      :aria-label="label"
      @click.stop="$emit('click', $event)"
      @keydown.enter="$emit('click', $event)"
      @keydown.space="$emit('click', $event)"
    >
      <Icon
        v-if="icon"
        :icon="icon"
        size="s"
        is-outlined
        :class="$style.icon"
      />
      <span :class="$style.label">
        {{ label }}
      </span>
    </div>
  </li>
</template>

<style module lang="scss">
.wrapper {
  margin: 0;
  @media (max-width: 767px) {
    border-bottom: 1px solid var(--color-borders);
  }
}
.item {
  position: relative;
  display: flex;
  padding: 0 1rem;
  align-items: center;
  height: 2.5rem;
  cursor: pointer;
  color: var(--color-text);
  @media (max-width: 767px) {
    padding: 1.5rem 1rem;
  }
  a {
    color: var(--color-text);
  }
  &:hover, &:focus {
    background: var(--bg-interactive-element-hover);
    text-decoration: none;
    color: var(--color-text);
  }
}
.icon {
  min-width: 2rem;
  max-width: 2rem;
}
.label {
  padding-right: 0.5rem;
  white-space: nowrap;
  display: inline-block;
  flex: 1;
  &::first-letter {
    text-transform: uppercase
  }
}
</style>
